import {Chip, Typography, styled} from '@mui/material'
import {useI18n} from 'store/Store'
import DanceListItem from 'components/Display/DanceListItem/DanceListItem'

const LearnedDances = ({
    learnedDances = [],
    handleMoveDance,
    handleRemoveDance,
}) => {
    const {i18n} = useI18n()

    const summaryTotalLabel = `${i18n.t('sessions.summaryTotal')}: ${
        learnedDances.length
    }`

    return (
        <Container>
            <Header>
                <Title variant="subtitle1">
                    {i18n.t('sessions.learnedDances')}
                </Title>
                <Chip
                    label={summaryTotalLabel}
                    color="primary"
                    variant="outlined"
                    size="small"
                />
            </Header>

            {learnedDances && learnedDances.length > 0 ? (
                <ListContainer>
                    {[...learnedDances].reverse().map((dance, index) => (
                        <DanceListItem
                            key={dance._id}
                            dance={dance}
                            index={index}
                            total={learnedDances.length}
                            showControls={false}
                            choreographersLabelKey="sessions.choreographersLabel"
                        />
                    ))}
                </ListContainer>
            ) : (
                <EmptyState variant="body2" color="text.secondary">
                    {i18n.t('sessions.noLearnedDances')}
                </EmptyState>
            )}
        </Container>
    )
}

export default LearnedDances

const Container = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
`

const Header = styled('div')`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
`

const Title = styled(Typography)`
    font-weight: 600;
    text-transform: none;
`

const ListContainer = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 8px;
`

const EmptyState = styled(Typography)`
    padding: 40px 16px;
    text-align: center;
`
